import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const SCModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(${pxToRem(10)});
  -webkit-backdrop-filter: blur(${pxToRem(10)});
`

interface SCModalContentProps {
  $opacity?: boolean;
  $type?: 'infos'|'camera';
  $hasVideo?: boolean;
}
export const SCModalContent = styled.div<SCModalContentProps>`
  background: white;
  border-radius: ${pxToRem(20)};
  padding: ${pxToRem(24)} ${pxToRem(16)} ${pxToRem(16)};
  min-height: 55vh;
  width: 80vw;
  max-height: 71vh;
  box-shadow: 0 ${pxToRem(6)} ${pxToRem(24)} rgba(0, 0, 0, 0.5);
  position: relative;
  font-size: ${pxToRem(15)};
  line-height: 1.6;
  opacity: 0.95;
  display: flex;
  flex-direction: column;

  .video-container {
    margin-top: ${pxToRem(16)};
    margin-bottom: 0;
    flex-shrink: 0;
    
    @media (min-width: 768px) and (orientation: portrait) {
      width: 100%;
      aspect-ratio: 16 / 9;
    }
    @media (min-width: 768px) and (orientation: landscape) {
      width: 50%;
      aspect-ratio: 16 / 9;
      align-self: center;
    }

    .react-player {
      @media (min-width: 768px) and (orientation: portrait) {
        width: 100% !important;
        height: 100% !important;
      }
      @media (min-width: 768px) and (orientation: landscape) {
        width: 100% !important;
        height: 100% !important;
      }
    }

    video {
      border-radius: ${pxToRem(12)};
    }
  }
`

export const SCTopBarInfo = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  margin-bottom: -${pxToRem(25)};
  pointer-events: none;
`;

export const SCTopBarIcon = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%; 
  padding: 8px;
  background: ${({ theme }) => theme.button_color || '#34b076'};
  box-shadow: 0 2px 10px rgba(0,0,0,0.7);
  z-index: 2;
`;

export const SCModalContentTitle = styled.div`
  margin-top: 30px;
  font-weight: 700;
  font-size: 20px;
  text-align: center;
  line-height: 22px;
  font-family: ${({ theme }) => theme.title_font || `'Nunito', sans-serif`};
`;

interface SCModalContentTextProps {
  $hasVideo?: boolean;
}
export const SCModalContentText = styled.div<SCModalContentTextProps>`
  margin-top: 22px;
  margin-bottom: 4px;
  flex: 1;
  overflow-y: auto;
  align-self: center;
  min-height: ${({ $hasVideo }) => $hasVideo ? '120px' : '280px'};
  max-height: ${({ $hasVideo }) => $hasVideo ? 'calc(100% - 200px)' : '280px'};
  font-family: ${({ theme }) => theme.text_font || `'Nunito', sans-serif`};
  text-align: center;
  padding: 0 5px;
  
  @media (orientation: landscape) {
    min-height: 0;
    max-height: none;
  }

  & > p {
    font-size: 16px;
    margin-bottom: 16px;
  }
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.button_color || '#34b076'};
    border-radius: 4px;
  }
`;

export const SCModalCloseIcon = styled.img`
  position: absolute;
  top: 15px;
  right: 22px;
  background: transparent;
  border: none;
  font-size: 48px;
  cursor: pointer;
  color: #232323;
`;

export const SCModalCloseButton = styled.button`
  align-self: center;
  margin-top: 24px;
  width: 50%;
  padding: 10px 0;
  background-color: ${({ theme }) => theme.photobooth_button_color || theme.button_color || '#34b076'};
  border-radius: 20px;
  color: white;
  border: none;
  font-size: 14px;
  font-family: ${({ theme }) => theme.title_font || `'Nunito', sans-serif`};
  font-weight: 700;
`;
